// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage .Layout-Container > .container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
}
.homepage p {
  margin-bottom: 50px;
  font-size: 24px;
  line-height: 30px;
}

.homepage__logo {
  margin-bottom: 25px;
  width: 256px;
}

.homepage__searchWrapper {
  max-width: 840px;
  width: 100%;
}

.HomePage-Container {
  margin-bottom: 5rem;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .HomePage-Container {
    margin-top: 0;
    padding: 0;
    min-height: initial;
  }
}
.HomePage-Container h1 {
  margin: 84px 0 32px;
  text-transform: uppercase;
  font-size: 3.75rem;
  font-family: "HeadingPro", Arial, sans-serif;
  line-height: 1.1;
}
@media (max-width: 767.98px) {
  .HomePage-Container h1 {
    margin: 0 0 24px;
    font-size: 40px;
  }
}
.HomePage-Container p {
  margin: 0 0 32px;
}

.CTA_Holder {
  position: relative;
  padding-left: 50px;
}
@media (max-width: 767.98px) {
  .CTA_Holder {
    padding-left: 0;
  }
}

.Image_Holder {
  position: relative;
  margin-right: -300px;
}
@media (max-width: 991.98px) {
  .Image_Holder {
    margin-right: 0;
  }
}
.Image_Holder img {
  max-width: 100%;
}

.Form_Holder {
  position: relative;
  margin: -93px 100px 0 0;
  max-width: 100%;
  width: 663px;
  border: 1px solid #003825;
  border-radius: 5px;
  background: #fff;
  margin-top: -91px;
  margin-top: -86px;
}
@media (max-width: 1199.98px) {
  .Form_Holder {
    margin: -115px 0 0 0;
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .Form_Holder {
    margin-top: -82px;
  }
}
@media (max-width: 767.98px) {
  .Form_Holder {
    margin-top: -40px;
  }
}
@media (max-width: 575.98px) {
  .Form_Holder {
    margin-top: -10%;
  }
}

.Form__header {
  padding: 16px 24px;
  background: #003825;
  color: #fff;
  font-weight: 700;
  font-size: 24px;
}

.Form__content {
  padding: 32px 24px;
}
@media (max-width: 575.98px) {
  .Form__content #mc_embed_signup_scroll > div {
    flex-direction: column;
  }
}
.Form__content p, .Form__content label {
  font-size: 18px;
  line-height: 24px;
}
.Form__content .form-control {
  height: 46px;
  border: 0;
  border-bottom: 1px solid #003825;
  border-radius: 5px 5px 0 0;
  background: rgba(0, 56, 37, 0.08);
}
.Form__content .form-control:focus, .Form__content .form-control:active {
  box-shadow: none;
}

.Form__submit {
  padding: 37px 0 0 32px;
}
@media (max-width: 575.98px) {
  .Form__submit {
    padding: 0;
  }
}
.Form__submit .btn-primary {
  padding: 5px 20px;
  height: 46px;
  border: 0;
  border-radius: 23px;
  background: #00a4ff;
  color: #fff;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  cursor: pointer;
}

.Lead-Supporter {
  margin-bottom: 80px;
}

.Lead-Supporter-Logo {
  display: block;
  margin: 0 auto;
  width: 70%;
}
@media (max-width: 767.98px) {
  .Lead-Supporter-Logo {
    margin-bottom: 20px;
    max-width: 240px;
  }
}

.Performance-Reports .Icon {
  color: #00ff7f;
  font-size: 96px;
}
@media (max-width: 767.98px) {
  .Performance-Reports .Icon {
    margin-bottom: 16px;
  }
}

.Shakers_Header {
  margin-top: 80px;
  text-align: center;
}
.Shakers_Header p {
  margin: 0 0 40px;
}

.Shakers_Container {
  margin: auto;
  margin-bottom: -5rem;
  width: 100%;
}

.Shakers_SelectorContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  margin-bottom: 1rem;
  margin-left: 0.25rem;
  width: 100%;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.5;
}
@media (max-width: 575.98px) {
  .Shakers_SelectorContainer {
    flex-direction: column;
  }
}

.Shakers_Selector {
  border-radius: 20px;
  text-align: left;
}
@media screen and (max-width: 767px) {
  .Shakers_Selector {
    flex-direction: column;
  }
}

.Shakers_Title {
  display: flex;
  margin: 0 2rem 0 0;
  font-weight: 400;
}
@media screen and (max-width: 767px) {
  .Shakers_Title {
    flex: 0 0 100%;
    margin: 0 0 16px;
  }
}

.Shakers_SelectorButton {
  display: flex;
  justify-content: flex-end;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.33;
}
@media screen and (max-width: 767px) {
  .Shakers_SelectorButton {
    flex: 0 0 100%;
    margin-right: 0rem;
  }
}
.Shakers_SelectorButton span {
  margin: 0 0.1rem;
  padding: 10px 1rem;
  background: rgba(0, 164, 255, 0.16);
  line-height: 20px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.Shakers_SelectorButton span.active {
  background: #00a4ff;
  color: #fff;
}
.Shakers_SelectorButton :nth-child(1) {
  border-top-left-radius: 1.5625rem;
  border-bottom-left-radius: 1.5625rem;
}
.Shakers_SelectorButton :nth-child(2) {
  border-top-right-radius: 1.5625rem;
  border-bottom-right-radius: 1.5625rem;
}

.panel {
  margin-bottom: 5rem;
}
.panel th, .panel td {
  padding: 32px 0;
}
@media (max-width: 767.98px) {
  .panel .pl-4 {
    padding-left: 12px !important;
  }
}
.panel .col--index {
  padding: 32px 0 32px 24px;
  width: 48px;
  text-align: right;
}
@media (max-width: 767.98px) {
  .panel .col--index {
    padding-left: 0 !important;
    width: 20px;
  }
}
.panel .col--name {
  padding-left: 16px;
}
.panel .col--average {
  width: 120px;
}
.panel .col--delta {
  width: 90px;
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./src/assets/scss/helpers/_variable.scss"],"names":[],"mappings":"AAKI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAJN;AAQE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AAUA;EACE,mBAAA;EACA,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,WAAA;AAPF;;AAUA;EACE,mBAAA;EACA,UAAA;AAPF;AC+CI;ED1CJ;IAKI,aAAA;IACA,UAAA;IACA,mBAAA;EANF;AACF;AAQE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CEXc;EFYd,gBAAA;AANJ;ACiCI;EDhCF;IAQI,gBAAA;IACA,eAAA;EALJ;AACF;AAQE;EACE,gBAAA;AANJ;;AAaA;EACE,kBAAA;EACA,kBAAA;AAVF;ACmBI;EDXJ;IAKI,eAAA;EATF;AACF;;AAYA;EACE,kBAAA;EACA,oBAAA;AATF;ACSI;EDFJ;IAKI,eAAA;EARF;AACF;AAUE;EACE,eAAA;AARJ;;AAYA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBEjFM;EFoFJ,iBAAA;EAGA,iBAAA;AAbJ;ACXI;EDWJ;IAgBI,oBAAA;IACA,WAAA;EAZF;AACF;ACjBI;EDWJ;IAoBI,iBAAA;EAVF;AACF;ACtBI;EDWJ;IAuBI,iBAAA;EARF;AACF;AC3BI;EDWJ;IA0BI,gBAAA;EANF;AACF;;AASA;EACE,kBAAA;EACA,mBEzFe;EF0Ff,WE3GM;EF4GN,gBAAA;EACA,eAAA;AANF;;AAQA;EACE,kBAAA;AALF;AC5CI;EDqDE;IACI,sBAAA;EANR;AACF;AAUE;EACE,eAAA;EACA,iBAAA;AARJ;AAWE;EACE,YAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,iCAAA;AATJ;AAWI;EAEE,gBAAA;AAVN;;AAcA;EACE,sBAAA;AAXF;ACnEI;ED6EJ;IAII,UAAA;EAVF;AACF;AAYE;EACE,iBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBErIO;EFsIP,WEzJI;EF0JJ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAVJ;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,cAAA;EACA,cAAA;EACA,UAAA;AAXF;AC9FI;EDsGJ;IAMI,mBAAA;IACA,gBAAA;EAVF;AACF;;AAcE;EACE,cEhKiB;EFiKjB,eAAA;AAXJ;ACzGI;EDkHF;IAKI,mBAAA;EAVJ;AACF;;AAgBA;EACE,gBAAA;EACA,kBAAA;AAbF;AAeE;EACE,gBAAA;AAbJ;;AAiBA;EACE,YAAA;EACA,oBAAA;EACA,WAAA;AAdF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAzBF;ACzII;EDwJJ;IAaI,sBAAA;EAxBF;AACF;;AA2BA;EACE,mBAAA;EACA,gBAAA;AAxBF;AA0BE;EAJF;IAKI,sBAAA;EAvBF;AACF;;AA0BA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;AAvBF;AAyBE;EALF;IAMI,cAAA;IACA,gBAAA;EAtBF;AACF;;AAyBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtBF;AAwBE;EAPF;IAQI,cAAA;IACA,kBAAA;EArBF;AACF;AAuBE;EACE,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,iBAAA;EACA,eAAA;EAEA,yBAAA;UAAA,iBAAA;AAtBJ;AAuBI;EACE,mBE9PK;EF+PL,WElRE;AF6PR;AAwBE;EACE,iCAAA;EACA,oCAAA;AAtBJ;AAwBE;EACE,kCAAA;EACA,qCAAA;AAtBJ;;AA0BA;EAEI,mBAAA;AAxBJ;AA2BE;EACE,eAAA;AAzBJ;AC7MI;EDyOF;IAEI,6BAAA;EA1BJ;AACF;AA6BE;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AA3BJ;ACvNI;ED+OF;IAMI,0BAAA;IACA,WAAA;EA1BJ;AACF;AA6BE;EACE,kBAAA;AA3BJ;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,WAAA;AA7BJ","sourcesContent":["@import '../assets/scss/helpers/component';\n\n\n.homepage {\n  .Layout-Container {\n    > .container {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      justify-content: center;\n      min-height: 100vh;\n    }\n  }\n\n  p {\n    margin-bottom: 50px;\n    font-size: 24px;\n    line-height: 30px;\n  }\n}\n\n.homepage__logo {\n  margin-bottom: 25px;\n  width: 256px;\n}\n\n.homepage__searchWrapper {\n  max-width: 840px;\n  width: 100%;\n}\n\n.HomePage-Container {\n  margin-bottom: rem(80px);\n  padding: 0;\n\n  @include media-breakpoint-down(lg) {\n    margin-top: 0;\n    padding: 0;\n    min-height: initial;\n  }\n\n  h1 {\n    margin: 84px 0 32px;\n    text-transform: uppercase;\n    font-size: rem(60px);\n    font-family: $font-family-alt;\n    line-height: 1.1;\n\n    @include media-breakpoint-down(sm) {\n      margin: 0 0 24px;\n      font-size: 40px;\n    }\n  }\n\n  p {\n    margin: 0 0 32px;\n  }\n}\n\n.Text_Holder {\n}\n\n.CTA_Holder {\n  position: relative;\n  padding-left: 50px;\n\n  @include media-breakpoint-down(sm) {\n    padding-left: 0;\n  }\n}\n\n.Image_Holder {\n  position: relative;\n  margin-right: -300px;\n\n  @include media-breakpoint-down(md) {\n    margin-right: 0;\n  }\n\n  img {\n    max-width: 100%;\n  }\n}\n\n.Form_Holder {\n  position: relative;\n  margin: -93px 100px 0 0;\n  max-width: 100%;\n  width: 663px;\n  border: 1px solid #003825;\n  border-radius: 5px;\n  background: $white;\n\n  @include media-breakpoint-down(xxl) {\n    margin-top: -91px;\n  }\n  @include media-breakpoint-down(xl) {\n    margin-top: -86px;\n  }\n  @include media-breakpoint-down(lg) {\n    margin: -115px 0 0 0;\n    width: 100%;\n  }\n  @include media-breakpoint-down(md) {\n    margin-top: -82px;\n  }\n  @include media-breakpoint-down(sm) {\n    margin-top: -40px;\n  }\n  @include media-breakpoint-down(xs) {\n    margin-top: -10%;\n  }\n}\n\n.Form__header {\n  padding: 16px 24px;\n  background: $gbp-rich-green;\n  color: $white;\n  font-weight: 700;\n  font-size: 24px;\n}\n.Form__content {\n  padding: 32px 24px;\n\n  @include media-breakpoint-down(xs) {\n    #mc_embed_signup_scroll {\n      > div {\n          flex-direction: column;\n      }\n    }\n  }\n\n  p, label {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .form-control {\n    height: 46px;\n    border: 0;\n    border-bottom: 1px solid $gbp-rich-green;\n    border-radius: 5px 5px 0 0;\n    background: rgba($gbp-rich-green, .08);\n\n    &:focus,\n    &:active {\n      box-shadow: none;\n    }\n  }\n}\n.Form__submit {\n  padding: 37px 0 0 32px;\n\n  @include media-breakpoint-down(xs) {\n    padding: 0;\n  }\n\n  .btn-primary {\n    padding: 5px 20px;\n    height: 46px;\n    border: 0;\n    border-radius: 23px;\n    background: $gbp-blue;\n    color: $white;\n    font-weight: 700;\n    font-size: 26px;\n    line-height: 36px;\n    cursor: pointer;\n  }\n}\n\n.Lead-Supporter {\n  margin-bottom: 80px;\n}\n\n.Lead-Supporter-Logo {\n  display: block;\n  margin: 0 auto;\n  width: 70%;\n\n  @include media-breakpoint-down(sm) {\n    margin-bottom: 20px;\n    max-width: 240px;\n  }\n}\n\n.Performance-Reports {\n  .Icon {\n    color: $gbp-electric-green;\n    font-size: 96px;\n\n    @include media-breakpoint-down(sm) {\n      margin-bottom: 16px;\n    }\n  }\n\n}\n\n\n.Shakers_Header {\n  margin-top: 80px;\n  text-align: center;\n\n  p {\n    margin: 0 0 40px;\n  }\n}\n\n.Shakers_Container {\n  margin: auto;\n  margin-bottom: rem(-80px);\n  width: 100%;\n  // color: $white;\n}\n\n\n// .Shaker_Icon {\n//   width: rem(130px);\n//   height: rem(90px);\n\n//   @include media-breakpoint-up(xs) {\n//     margin-top: 100px;\n//   }\n// }\n\n.Shakers_SelectorContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  margin-left: 0.25rem;\n  width: 100%;\n  font-weight: bold;\n  font-size: rem(20px);\n  line-height: 1.5;\n\n  @include media-breakpoint-down(xs) {\n    flex-direction: column;\n  }\n}\n\n.Shakers_Selector {\n  border-radius: 20px;\n  text-align: left;\n\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n}\n\n.Shakers_Title {\n  display: flex;\n  margin: 0 2rem 0 0;\n  font-weight: 400;\n\n  @media screen and (max-width: 767px) {\n    flex: 0 0 100%;\n    margin: 0 0 16px;\n  }\n}\n\n.Shakers_SelectorButton {\n  display: flex;\n  justify-content: flex-end;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.33;\n\n  @media screen and (max-width: 767px) {\n    flex: 0 0 100%;\n    margin-right: 0rem;\n  }\n\n  span {\n    margin: 0 0.1rem;\n    padding: 10px 1rem;\n    background: rgba($gbp-blue, .16);\n    line-height: 20px;\n    cursor: pointer;\n\n    user-select: none;\n    &.active {\n      background: $gbp-blue;\n      color: $white;\n    }\n  }\n  :nth-child(1) {\n    border-top-left-radius: rem(25px);\n    border-bottom-left-radius: rem(25px);\n  }\n  :nth-child(2) {\n    border-top-right-radius: rem(25px);\n    border-bottom-right-radius: rem(25px);\n  }\n}\n\n.panel {\n  @include media-breakpoint-down(xl) {\n    margin-bottom: rem(80px);\n  }\n\n  th, td {\n    padding: 32px 0;\n  }\n\n  .pl-4 {\n    @include media-breakpoint-down(sm) {\n      padding-left: 12px !important;\n    }\n  }\n\n  .col--index {\n    padding: 32px 0 32px 24px;\n    width: 48px;\n    text-align: right;\n\n    @include media-breakpoint-down(sm) {\n      padding-left: 0 !important;\n      width: 20px;\n    }\n  }\n\n  .col--name {\n    padding-left: 16px;\n  }\n\n  .col--average {\n    width: 120px;\n  }\n\n  .col--delta {\n    width: 90px;\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
